export const GET_REFLECTIVE_DISCUSSION =
  'src/modules/revalidation/reflectiveDiscussion/GET_REFLECTIVE_DISCUSSION';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/revalidation/reflectiveDiscussion/CANCEL_ALL_API_REQUESTS';
export const POST_REFLECTIVE_DISCUSSION =
  'src/modules/revalidation/reflectiveDiscussion/POST_REFLECTIVE_DISCUSSION';